import { Box, Table } from '@factorialco/deprecated-design-system'

import { Amount } from 'modules/finance/components/JournalsEntry/Datatable/_Amount'

interface SummaryMoneyCellProps {
  amountCents: number
  currency: string
}

export const SummaryMoneyCell = ({ amountCents, currency }: SummaryMoneyCellProps) => {
  return (
    <Table.Cell noBorder paddingX="s4" paddingY="s2" width={100}>
      <Box textAlign="right" maxWidth="s120">
        <Amount amountCents={amountCents} currency={currency} />
      </Box>
    </Table.Cell>
  )
}
